/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Row, Col } from 'react-flexa';
import Image from '../../components/Image';
import Typography from '../../components/Typography';
import OtherRetailers from './subcomponents/Comparison/OtherRetailers';
import DirectBuy from './subcomponents/Comparison/DirectBuy';
import CallUs from './CallUs';

const styles = theme => ({
  root: {
    maxWidth: 1343,
    margin: '4rem auto',
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      padding: '1rem 1rem',
      margin: '2rem auto'
    }
  },
  refrigerators: {
    width: '1000px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '100%'
    }
  },
  textContainer: {
    zIndex: '1',
    backgroundColor: 'white',
    border: '1px solid #d6dbdf',
    boxShadow: '0 80px 60px -50px rgba(28,0,0,0.3)',
    borderBottom: `4px solid ${theme.palette.primary.main}`,
    maxWidth: 700,
    margin: '0 auto',
    textAlign: 'center',
    position: 'relative',
    padding: '3rem 2rem 3rem',
    paddingBottom: '5%',
    marginTop: '-75px',
    [theme.breakpoints.up('md')]: {
      marginTop: '-330px'
    }
  },
  title: {
    fontSize: '3rem',
    color: '#222',
    lineHeight: 1,
    margin: '20px 0',
    [theme.breakpoints.down('321')]: {
      fontSize: '2rem'
    }
  },
  paragraph: {
    lineHeight: 1.5,
    maxWidth: '92%',
    margin: '0 auto'
  },
  comparisonPipeline: {
    margin: '0 auto',
    padding: '2% 0 3%'
  },
  pipelineTitle: {
    fontFamily: "'Lato', san-serif",
    fontSize: '2rem',
    letterSpacing: '2px',
    color: theme.palette.secondary.dark,
    opacity: '0.8',
    [theme.breakpoints.down('390')]: {
      fontSize: '1.5rem',
      marginTop: '3rem'
    }
  },
  pipelineSubTitle: {
    fontFamily: "'Lato', san-serif",
    fontSize: '1.25rem',
    letterSpacing: '2px',
    marginBottom: '8%'
  },
  CAImage: {
    paddingTop: '.25rem',
    paddingBottom: '.25rem',
    margin: '5px auto'
  },
  CAStars: {
    maxWidth: '75%'
  },
  CAText: {
    letterSpacing: '0.6px',
    lineHeight: '38px',
    fontSize: '1.6rem',
    [theme.breakpoints.down('401')]: {
      fontSize: '1.3rem',
      marginTop: '0.5rem',
      textAlign: 'center'
    },
    [theme.breakpoints.down('341')]: {
      fontSize: '1rem',
      marginTop: 0
    }
  },
  rightHeader: {
    letterSpacing: '4px',
    lineHeight: '30px',
    fontSize: '1.8rem',
    marginBottom: '8px'
  },
  rightBody: {
    letterSpacing: '0.45px',
    lineHeight: '36px',
    fontSize: '1.2rem'
  },
  consumerAffairsIcons: {
    marginTop: '15px',
    width: '100%'
  },
  consumerAffairsContainer: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('426')]: {
      flexDirection: 'column'
    }
  },
  consumerAffairsItem: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    alignItems: 'flex-start',
    [theme.breakpoints.down('426')]: {
      marginBottom: '20px'
    }
  },
  consumerAffairsIconContainer: {
    marginTop: '20px',
    marginRight: '10px',
    marginLeft: '10px',
    [theme.breakpoints.down('426')]: {
      marginTop: 0
    }
  },
  consumerAffairsText: {
    textAlign: 'left',
    marginTop: '20px',
    [theme.breakpoints.down('769')]: {
      marginTop: 0
    }
  }
});

class Comparison extends React.Component {
  render() {
    // eslint-disable-next-line react/prop-types
    const { classes, locRef } = this.props;
    return (
      <div className={classes.root} ref={locRef}>
        <Image
          src="/pricingpage/Fridge Comparison@2x.jpg"
          className={classes.refrigerators}
        />
        <div className={classes.textContainer}>
          <Typography variant="subtitle1" color="primary" bold upper>
            how can we save so much?
          </Typography>
          <Typography
            className={classes.title}
            variant="h3"
            color="secondary.dark"
            bold
          >
            Same Products,
            <br />2 Different Prices
          </Typography>
          <Typography className={classes.paragraph} variant="body2">
            When you buy through DirectBuy, you purchase directly through the
            manufacturer without paying significant retail markups<sup>2</sup>{' '}
            and only pay a nominal service fee with DirectBuy. We cut out the
            middleman, so you can buy direct.
          </Typography>
        </div>
        <div className={classes.comparisonPipeline}>
          <Row>
            <Col xs={12} sm={12} md={5}>
              <Typography className={classes.pipelineTitle} variant="h3" upper>
                why you pay extra
              </Typography>
              <Typography
                className={classes.pipelineSubTitle}
                variant="h4"
                color="primary"
                upper
              >
                (with them...)
              </Typography>
              <OtherRetailers />
            </Col>
            <Col xs={12} sm={12} md={2}>
              <Image src="/pricingpage/comparison-versus.svg" />
            </Col>
            <Col xs={12} sm={12} md={5}>
              <Typography className={classes.pipelineTitle} variant="h3" upper>
                why you save
              </Typography>
              <Typography
                className={classes.pipelineSubTitle}
                variant="h4"
                color="primary"
                upper
              >
                (with us!)
              </Typography>
              <DirectBuy />
            </Col>
          </Row>
        </div>
        <CallUs primary textProps={{ fontSize: 16 }} />
        <Col
          xs={12}
          sm={12}
          md={3}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '2rem 0',
            margin: '40px auto 20px auto'
          }}
        >
          <Image
            className={`${classes.CAImage} ${classes.CAStars}`}
            src="/homepage/consumer-4-stars.svg"
          />
          <Image
            className={classes.CAImage}
            src="/homepage/consumer affairs.svg"
          />
          <Typography
            variant="body1"
            color="secondary.main"
            className={classes.CAText}
          >
            Our Members Love Us!
          </Typography>
        </Col>
        <div style={{ textAlign: 'center' }}>
          <Typography variant="h1">
            Perks Of Being A DirectBuy Member
          </Typography>
          <Typography className={classes.paragraph} variant="body2">
            Instead of upcharging our customers, like ordinary retailers, we
            simply charge a small annual membership and handling
            <br />
            fee, so we can keep offering you unbeatable deals!
          </Typography>
        </div>
        <div
          className={classes.consumerAffairsContainer}
          id="consumerAffairsContainer"
        >
          <div className={classes.consumerAffairsItem}>
            <div className={classes.consumerAffairsIconContainer}>
              <Image
                className={classes.consumerAffairsIcons}
                src="/pricingpage/consumer-affairs-icons/Monitor@2x.png"
              />
            </div>
            <div className={classes.consumerAffairsText}>
              <div style={{ marginBottom: '20px' }}>
                <Typography variant="body1" color="secondary.dark">
                  Exclusive Online Access
                </Typography>
              </div>
              <Typography>
                Shop at your leisure with 24/7 online access to savings.
              </Typography>
            </div>
          </div>
          <div className={classes.consumerAffairsItem}>
            <div className={classes.consumerAffairsIconContainer}>
              <Image
                className={classes.consumerAffairsIcons}
                src="/pricingpage/consumer-affairs-icons/Cart Icon@2x.png"
              />
            </div>
            <div className={classes.consumerAffairsText}>
              <div style={{ marginBottom: '20px' }}>
                <Typography
                  className={classes.consumerAffairsText}
                  variant="body1"
                  color="secondary.dark"
                >
                  Concierge Shopping
                </Typography>
              </div>
              <Typography className={classes.consumerAffairsText}>
                Ever wanted your own personal shopper? Try our concierge
                services when you join today!
              </Typography>
            </div>
          </div>
          <div className={classes.consumerAffairsItem}>
            <div className={classes.consumerAffairsIconContainer}>
              <Image
                className={classes.consumerAffairsIcons}
                src="/pricingpage/consumer-affairs-icons/Ruler@2x.png"
              />
            </div>
            <div className={classes.consumerAffairsText}>
              <div style={{ marginBottom: '20px' }}>
                <Typography
                  className={classes.consumerAffairsText}
                  variant="body1"
                  color="secondary.dark"
                >
                  Project Coordinators
                </Typography>
              </div>
              <Typography className={classes.consumerAffairsText}>
                Our coordinators will help ensure your plans and project happen
                without a problem.
              </Typography>
            </div>
          </div>
          <div className={classes.consumerAffairsItem}>
            <div className={classes.consumerAffairsIconContainer}>
              <Image
                className={classes.consumerAffairsIcons}
                src="/pricingpage/consumer-affairs-icons/Verified badge@2x.png"
              />
            </div>
            <div className={classes.consumerAffairsText}>
              <div style={{ marginBottom: '20px' }}>
                <Typography
                  className={classes.consumerAffairsText}
                  variant="body1"
                  color="secondary.dark"
                >
                  Savings Guarantee
                </Typography>
              </div>
              <Typography className={classes.consumerAffairsText}>
                Did you find a product cheaper somewhere else? We'll not only
                match it, we'll{' '}
                <i>
                  <b>beat it</b>
                </i>
                !
              </Typography>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Comparison);
